import React, { useEffect, useState } from 'react';
import network from '../../../assets/sso/networks.svg';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { UserData } from '../../../types/user.types';
import { NETWORKS } from '../../../constants/networks.config';
import NetworkItem from '../../../components/NetworkItem';
import { selectUserGroupement } from '../../../selectors/userSelectors';

const NetworkAdmin: React.FC = () => {
    const [users, setUsers] = useState<[UserData] | null>(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const adminGroupement = useSelector(selectUserGroupement);

    useEffect(() => {
        if (adminGroupement === undefined) {
            return;
        }

        void axios
            .get(`/api/users?groupement.id=${adminGroupement.id}&isActive=1`)
            .then(response => {
                setUsers(response.data['hydra:member']);
                setTotalUsers(response.data['hydra:totalItems']);
            });
    }, [adminGroupement]);

    function getTotalConnexions(users: UserData[]) {
        const totals: Record<string, number> = {};

        NETWORKS.forEach(network => {
            totals[network.name] = users.filter(user => user[network.key]).length;
        });

        return totals;
    }

    const totals = users ? getTotalConnexions(users) : {};

    return (
        <div className="h-full flex flex-col justify-between max-h-[300px]">
            <div className="flex items-center justify-start gap-2 w-full">
                <img className="h-[40px]" src={network} alt="networks icon" />
                <div className="text-neutral-900 text-heavy font-semibold leading-normal">
                    Mes réseaux
                </div>
            </div>
            {users ? (
                <>
                    <div className="flex flex-col justify-items-end gap-[12px] w-full">
                        {NETWORKS.map(network => (
                            <NetworkItem
                                key={network.key}
                                logo={network.logo}
                                displayName={network.displayName}
                                variant="count"
                                count={totals[network.name] || 0}
                                totalCount={totalUsers}
                                sizeClass="medium"
                            />
                        ))}
                    </div>
                </>
            ) : (
                <p>Chargement...</p>
            )}
        </div>
    );
};

export default NetworkAdmin;
